
	import { defineComponent } from 'vue';

	import store from '@/store';

	export default defineComponent({
		name: 'Word',
		props: {
			word: {
				type: String,
				required: true,
			},
			correctLetters: {
				type: Array,
				required: true,
			},
		},
		emits: ['gameover'],
		computed: {
			letters() {
				const letters: Array<{ letter: string; i: number }> = [];

				this.word.split('').map((letter, i) => letters.push({ letter, i }));

				return letters;
			},
		},
		watch: {
			correctLetters(v: Array<string>) {
				let flag = true;

				this.letters.forEach(o => {
					if (!v.includes(o.letter)) flag = false;
				});

				if (flag) {
					store.addWord(this.word);

					this.$emit('gameover');
				}
			},
		},
	});
